<template>
  <OpportunityDetails
    :ratio="1/4"
    :title="$t('Summary')"
    :next-title="$t('Operation details')"
    opportunity-attribute="summary"
    next-link="operation-details"
    back-route="."
  />
</template>

<script>
import OpportunityDetails from './OpportunityDetails.vue';

export default {
  name: 'OpportunitySummary',
  components: {
    OpportunityDetails,
  },
};
</script>
